import React from 'react'
import { matchPath } from 'react-router-dom'
import { SearchFilterProvider } from '../../../views/providers'
import { PropertiesPage } from '.'
import { ROUTES } from '../../../constants/routes'
import PropertiesProvider from '../PropertiesProvider'
import { ContactsProvider } from 'modules/contacts'
import EditProperty from './EditProperty/EditProperty'

const PropertiesRoute = (props: any) => {
  const isEditPath = matchPath(props.location.pathname, {
    path: ROUTES.editProperty,
    exact: true,
    strict: false,
  })

  return (
    <PropertiesProvider {...props}>
      <ContactsProvider {...props}>
        <SearchFilterProvider location={props.location}>
          <PropertiesPage />
          {isEditPath && <EditProperty />}
        </SearchFilterProvider>
      </ContactsProvider>
    </PropertiesProvider>
  )
}

export default PropertiesRoute
